export default "__VITE_ASSET__d9773746__"